import { render, staticRenderFns } from "./TableRowGroup.vue?vue&type=template&id=64e8e78c&scoped=true"
import script from "./TableRowGroup.vue?vue&type=script&lang=js"
export * from "./TableRowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8e78c",
  null
  
)

export default component.exports